import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Box,
  TableHead,
  TableRow,
  Paper,
  IconButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CheckIcon from "@mui/icons-material/Check";
import MemberService from "../../services/MemberService";
import { formatDate } from "../../Utils/DateUtils";

const MemberSearchDialog = ({ open, onClose, onSelect }) => {
  const [search, setSearch] = useState("");
  const [members, setMembers] = useState([]);

  const handleSearch = async () => {
    try {
      const response = await MemberService.fullSearch(search);
      // If response.data is an array, assign it to members; if it's not an array but has an object, create an array and assign it to members
      if (Array.isArray(response.data)) {
        setMembers(response.data);
      } else if (response.data) {
        setMembers([response.data]);
      }
    } catch (error) {
      console.error("Error searching members:", error);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const handleSelect = (member) => {
    onSelect(member);
    setSearch(""); // Clear the search textbox
    setMembers([]); // Clear the members list
    onClose(); // Close the dialog
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Search Member</DialogTitle>
      <DialogContent>
        <Box display="flex" alignItems="center" marginTop={1}>
          <TextField
            label="Search by Member ID or Last Name"
            fullWidth
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyPress={handleKeyPress}
          />
          <IconButton onClick={handleSearch}>
            <SearchIcon />
          </IconButton>
        </Box>
        <TableContainer component={Paper} style={{ marginTop: "10px" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Member ID</TableCell>
                <TableCell>First Name</TableCell>
                <TableCell>Last Name</TableCell>
                <TableCell>DOB</TableCell>
                <TableCell>Select</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {members.map((member) => (
                <TableRow key={member.id}>
                  <TableCell>{member.id}</TableCell>
                  <TableCell>{member.firstName}</TableCell>
                  <TableCell>{member.lastName}</TableCell>
                  <TableCell>{formatDate(member.dob)}</TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<CheckIcon />}
                      onClick={() => handleSelect(member)}
                    >
                      Select
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MemberSearchDialog;
